import { GameRoomState } from "@presidents/game-engine";

export function playerInGameRoom(
  playerId?: string,
  players?: GameRoomState["players"]
) {
  return (playerId && players?.some(({ id }) => id === playerId)) || false;
}
